<template>
  <footer v-if="kql.site?.footer">
    <span v-html="kql.site.footer" />
    <LanguageSwitcher />
  </footer>
</template>

<script setup>
import { useStore } from '@/KQL.js'
const kql = useStore()
</script>

<style scoped>
footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 4rem var(--offset);
  margin-top: 8rem;
  border-top: 1px solid var(--fg-20);
  font-size: 1rem;
  opacity: 0.5;
}
</style>
